import { format, type Locale } from 'date-fns'
import { de, enUS } from 'date-fns/locale'
import { getLocale } from '~/paraglide/runtime.js'

export type AppDateLocale = 'de' | 'en'

export function appDateLocale(): AppDateLocale {
  return getLocale() === 'en' ? 'en' : 'de'
}

export function dateFnsLocale(locale: AppDateLocale = appDateLocale()): Locale {
  return locale === 'de' ? de : enUS
}

/** "18. Oktober 2026" / "October 18th, 2026". */
export function formatLongDate(date: Date, locale: AppDateLocale = appDateLocale()): string {
  return format(date, 'PPP', { locale: dateFnsLocale(locale) })
}
